import classNames from "classnames";

import type { TableColumn } from "./types";

export interface ICell {
    className?: string;
    column?: TableColumn;
    children?: JSX.Element;
}

const alignmentStyles: Record<Exclude<TableColumn["align"], undefined>, string> = {
    right: "text-right",
    left: "text-left",
    center: "text-center",
};

function Cell(props: ICell) {
    return (
        <td
            className={classNames(
                props.column?.width ? "flex-none" : "flex-1 min-w-0",
                classNames(alignmentStyles[props.column?.align || "left"]),
                props.className,
            )}
            style={{
                width: props.column?.width ? `${props.column?.width}px` : undefined,
                minWidth: props.column?.minWidth ? `${props.column?.minWidth}px` : undefined,
            }}
        >
            {props.children || null}
        </td>
    );
}

export default Cell;
